import 'jspdf-autotable'

class QuickbooksController {
  constructor($rootScope, $http, AuthenticationService, toastr) {
    "ngInject";
    this.name = 'integrations';
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.auth = AuthenticationService;
    this.toastr = toastr;
    this.qb = {};
    this.connectUrl = $rootScope.apiHost+"/api/integrations/qb/connect";
    this.qbAccounts = [];
    this.quickbooksIntegration = null;
    this.statusLoading = true;

    let self = this;

    $http.get($rootScope.apiHost+"/api/integrations/qb/status", {withCredentials: true}).then(function (success) {
      self.quickbooksIntegration = success.data;
    }, function () {
      self.quickbooksIntegration = { enabled: false, connected: false };
    }).finally(function () {
      self.statusLoading = false;
    });

    this.$http.get(self.$rootScope.apiHost+"/api/integrations/qb/accounts?type=All", {withCredentials: true}).then(function (success) {
      self.qbAccounts = success.data;
    });

    // $http.get($rootScope.apiHost+"/api/integrations/qb/accounts", {withCredentials: true}).then(function (success) {
    //   self.qbAccounts = success.data;
    //
    //   self.qbAccounts.forEach(function (account) {
    //     if(account.id == self.quickbooksIntegration.incomeAccount) {
    //       self.quickbooksIntegration.incomeAccount = account;
    //     }
    //   });
    // });


  }

  getQuickbooksAccountName(qbId) {

    let name = undefined;
    if(this.qbAccounts) {
      this.qbAccounts.forEach(function (account) {
        if(account.id === (qbId+"")) {
          name = account.acctNum + " - " + account.fullyQualifiedName;
        }
      })
    }

    return name;
  }

  qbActiveToggle() {
    this.updateQBIntegrationDetails("enabled", this.quickbooksIntegration.enabled);
  }

  updateQBIntegrationDetails(parameter, value) {

    let self = this;
    let obj = {};
    obj[parameter] = value;

    this.$http.patch(this.$rootScope.apiHost+"/api/integrations/qb", obj, {withCredentials: true}).then(function (success) {
      self.toastr.success("Quickbooks Integration Details Successfully Updated.", "Success");
      self.quickbooksIntegration = success.data;
    }, function (failure) {
      self.toastr.error("Could not update Quickbooks Integration Details", "ERROR");
    });
  }

  disconnectQb() {
    let self = this;
    self.$http.get(self.$rootScope.apiHost+"/api/integrations/qb/disconnect", {withCredentials: true}).then(function (success) {
      self.quickbooksIntegration = success.data;
    });
  }

  connectQb() {
    var left = (screen.width - 550) / 2;
    var top = (screen.height - 650) / 4;


    window.open (this.$rootScope.apiHost+"/api/integrations/qb/connect", "_blank","menubar=1,resizable=1,width=550,height=650,top="+top+",left="+left);
  }

  updateQbIncomeAccount(incomeAccount) {
    this.updateQBIntegrationDetails("incomeAccount", incomeAccount.id);
  }

  syncDataWithQuickbooks() {
    this.$http.get(this.$rootScope.apiHost+"/api/integrations/qb/customers/sync", {withCredentials: true});
  }


}

export default QuickbooksController;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/quickbooks/quickbooks.controller.js